import {
  faqArticleBodySchema,
  faqCollectionBodySchema,
  faqPagesBodySchema,
  faqThemeBodySchema,
} from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod";

export const getFaq = {
  name: "getFaq" as const,
  input: z.object({
    include: z
      .object({
        pages: z.boolean().optional(),
        collections: z.boolean().optional(),
        articles: z.boolean().optional(),
        theme: z.boolean().optional(),
      })
      .optional(),
  }),
  output: z.object({
    theme: z.optional(faqThemeBodySchema),
    pages: z.optional(z.map(z.string(), faqPagesBodySchema)),
    collections: z.optional(z.map(z.string(), faqCollectionBodySchema)),
    articles: z.optional(z.map(z.string(), faqArticleBodySchema)),
  }),
};
